import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";


export const getClassification = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.Cutomer.GET_CLASSIFICATION_LIST,
        { params: params }
    );
    console.log("🚀 ~ file: ClassificationRepository.ts ~ line 9 ~ getClassification ~ response", response);
    return response;
}

export const addClassification = async (body: any) => {
    return axiosInstance.post(API_ENDPOINTS.Cutomer.ADD_CLASSIFICATION, body);
};
export const updateClassification = async (body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.Cutomer.UPDATE_CLASSIFICATION}`, body);
};